/**
 * Serviço para comunicação com a API de Designação de Cursos
 * Usado por administradores de empresa (company-root)
 */

import request from "@/utils/request";

/**
 * Listar funcionários da empresa
 */
export function getEmployees(params) {
  return request({
    url: "/course-assignment/employees",
    method: "get",
    params,
  });
}

/**
 * Listar departamentos da empresa
 */
export function getDepartments(params) {
  return request({
    url: "/course-assignment/departments",
    method: "get",
    params,
  });
}

/**
 * Listar unidades de negócio da empresa
 */
export function getBusinessUnits(params) {
  return request({
    url: "/course-assignment/business-units",
    method: "get",
    params,
  });
}

/**
 * Listar cursos disponíveis
 */
export function getCourses(params) {
  return request({
    url: "/course-assignment/courses",
    method: "get",
    params,
  });
}

/**
 * Designar curso para participantes
 */
export function assignCourse(data) {
  return request({
    url: "/course-assignment/assign",
    method: "post",
    data,
  });
}

/**
 * Validar elegibilidade de funcionários para matrícula
 */
export function validateEnrollments(data) {
  return request({
    url: "/course-assignment/validate-enrollments",
    method: "post",
    data,
  });
}

/**
 * Listar designações de cursos
 */
export function getAssignments(params) {
  return request({
    url: "/course-assignment/assignments",
    method: "get",
    params,
  });
}
